import { Component, Input, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'skychute-svg-loader',
    templateUrl: './svg-loader.component.html',
    styleUrls: ['./svg-loader.component.scss'],
    standalone: false
})
export class SvgLoaderComponent {
  private domSanitizer = inject(DomSanitizer);
  data = inject<{
    title: string;
    content: SafeHtml | string;
}>(MAT_DIALOG_DATA);

  @Input() title = '';
  @Input() content: SafeHtml | string = '';

  constructor() {
    const data = this.data;

    this.title = data.title;
    if (typeof data.content === 'string') {
      this.content = this.domSanitizer.bypassSecurityTrustHtml(data.content);
    }
  }
}
